import { Auth0Verrific, IOfficeSettings } from 'verrific-plus-schema';
import CommunicationService, { IResponse } from '../../Utils/CommunicationService';

export interface ISingleDO {
  externalId: string;
  id: string;
  key: string;
  name: string;
  outsourceCompany: string;
  outsourceEnable: boolean;
  planType: string;
  scheduleIntegration?: {
    integration?: {
      locationId: number,
      subdomain: string
    }
  }
}

export const getAvailableOffices = async (token?: string) => {
  let result: IResponse<ISingleDO[]> | undefined;
  if (token) {
    result = await CommunicationService.getInstance().secureCall<ISingleDO[]>({
      type: 'GET',
      path: '/api/dentaloffice/user/all',
      headers: {
        authorization: `Bearer ${token}`
      },
      cached: false
    });
  } else {
    result = await CommunicationService.getInstance().secureCall<ISingleDO[]>({
      type: 'GET',
      path: '/api/dentaloffice/user/all',
      cached: false
    });
  }
  if (result.body) {
    Auth0Verrific.setOfficesSettings(result.body as unknown as IOfficeSettings[]);
    return result.body;
  }
};

export const getDentalOfficeInformation = async (officeId: string) => {
  const result = await CommunicationService.getInstance().secureCall<ISingleDO>({
    type: 'GET',
    path: `/api/dentaloffice/${officeId}`
  });
  if (result.body) {
    return result.body;
  }
};
